import sessions from "./data.js";
import { generateRandomString, log } from "@tumbodash/browserPackages";
import store from "../store.js";

/**
 * @description Create session
 * @returns {string} - Returns sessionId of the created session
 */

function create({ sessionId, slug = "" }: { sessionId?: string; slug?: string } = {}) {
	log.main("Creating session", sessionId, slug);
	if (!sessionId || sessionId === "") {
		sessionId = generateRandomString(16) as string;
	}
	sessions.set(sessionId, {
		id: sessionId,
		ts: Date.now(),
		state: {},
		slug: slug,
		socket: store.socket,
		playerId: store.playerId,
		mountPoint: null,
		cleanup: []
	});
	return sessionId;
}

export { create };

export default create;
